module.exports = __webpack_public_path__ + "img/Physithon.bfd12154.png";